import React, { useState } from "react";

const SourceTab = ({ handleLayoutChange, selectedLayout,updateFacebookLikeButtonTabData,facebookLikeButtonTabData }) => {
    const [sourceType, setSourceType] = useState(facebookLikeButtonTabData.source_type);
    const [sourceTypeDropdownOpen, setSourceTypeDropdownOpen] = useState(false);
    const [customUrl, setShowCustomUrl] = useState(facebookLikeButtonTabData.custom_url);
    const [type, setType] = useState(facebookLikeButtonTabData.type);
    const [typeDropdownOpen, setTypeDropdownOpen] = useState(false);

    // Handlers Source Type Change
    const handleSourceTypeChange = (type) => {
        setSourceType(type);
        updateFacebookLikeButtonTabData("source_type", type);
        setSourceTypeDropdownOpen(false);
    };

    // Handlers Show Custom Url Change
    const handleShowCustomUrlChange = (e) => {
        const value = e.target.value;
        setShowCustomUrl(value);
        updateFacebookLikeButtonTabData("custom_url", value); 
    };

     // Handlers Type Change
    const handleTypeChange = (type) => {
        setType(type);
        updateFacebookLikeButtonTabData("type", type);
        setTypeDropdownOpen(false);
    };
    
    return (
        <div className="testimonials-side-baar-layout-tab">
            <span>Source</span>
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Source</span>
                    <div className="color-pikr-box" onClick={() => setSourceTypeDropdownOpen(!sourceTypeDropdownOpen)}>
                        <em>{sourceType}</em>
                        {sourceTypeDropdownOpen && (
                            <ul className="dropdown-list">
                                {["Current Page","Custom URL"].map((type) => (
                                    <li key={type} onClick={() => handleSourceTypeChange(type)}>
                                        {type}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>

                {sourceType === "Custom URL" && (
                <>
                    <div className="side-baar-box-header">
                        <div className="box-header-row input-fild">
                            <label>Custom Url</label>
                            <input type="text" value={customUrl} onChange={handleShowCustomUrlChange}placeholder="" />
                        </div>
                    </div>
                </> 
                )}
                
            </div>

            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Type</span>
                    <div className="color-pikr-box" onClick={() => setTypeDropdownOpen(!typeDropdownOpen)}>
                        <em>{type}</em>
                        {typeDropdownOpen && (
                            <ul className="dropdown-list">
                                {["Like","Recommend"].map((value_type) => (
                                    <li key={type} onClick={() => handleTypeChange(value_type)}>
                                        {value_type}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SourceTab;